$ = jQuery;
export const carousel = {
  init: function () {
    $(".archipel-carousel").owlCarousel({
      loop: false,
      nav: false,
      dots: true,
      fluidSpeed: 40,
      animateOut: "animate__fadeOut",
      animateIn: "animate__fadeIn",
      items: 1,
    });
    $(".logos-carousel").owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 4000,
      autoplaySpeed: 4000,
      autoplayHoverPause: false,
      margin: 20,
      stagePadding: 10,
      dots: false,
      items: 7,

      smartSpeed: 450,
      responsive: {
        0: {
          items: 2,
        },
        768: {
          items: 4,
        },
        1024: {
          items: 5,
        },
        1280: {
          items: 7,
        },
      },
    });
  },
};
